<template>
  <schedule-center
    :base-url="serveUrl"
    :admin-center-url="adminCenterUrl"
    :request="request"
    show-management
    :loginUsrDepartment = "$store.state.user.userInfo.accounts[0].organizationName"
    :showFilter = "HIDE_SCHEDULE_SEARCH !== '1'"
  ></schedule-center>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../../store";
import request from '@/utils/request';
import configR from '@/configs.js';
export default {
  name: "ScheduleManagement",
  data(){
    return {
      serveUrl:configR.envConfigs.PORTAL_API,
      HIDE_SCHEDULE_SEARCH:configR.envConfigs.HIDE_SCHEDULE_SEARCH,
     adminCenterUrl:configR.envConfigs.ADMIN_CENTER_API,
     request:request
    }
  }
};
</script>
